import styled from "styled-components";

export const CashbackLogo = styled.img`
    width: 200px;
    height: auto;
    object-fit: contain;
    cursor: pointer;
    margin-top: 2rem;

    @media (min-width: 768px) {
        width: 170px;
    }

    @media (min-width: 1200px) {
        width: 280px;
    }
`;
